import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateCreateMatch } from '../../models'

interface CreateMatchParams {
  sessionId: number
  creditcardItemIds: number[]
  statementItemIds: number[]
}

// Hook-only command (ADR-2): the Match button, variance/Invalid Currency
// gating (BHV-031/032) and the match-without-statement-items
// ConfirmationModal (BHV-033) are ALL FS-owned — the FS calls
// `commands.match` only after its own gating/confirmation.
export const useCreateMatchPresenter = () => {
  const intl = useProcurifyIntl()
  const { createMatch, isMatching } = useMutateCreateMatch()

  const match = async (params: CreateMatchParams): Promise<void> => {
    try {
      await createMatch(params)

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
      throw error
    }
  }

  return {
    commands: {
      match,
    },
    states: {
      isMatching,
    },
  }
}
